import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../api';

const s = {
  page: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#eff6ff' },
  card: { background: '#fff', padding: 40, borderRadius: 16, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', width: '100%', maxWidth: 420, textAlign: 'center' },
  title: { fontSize: 28, fontWeight: 700, color: '#1e3a8a', marginBottom: 8 },
  sub: { color: '#64748b', marginBottom: 28 },
  success: { color: '#16a34a', background: '#f0fdf4', border: '1px solid #bbf7d0', padding: '16px', borderRadius: 8, marginBottom: 16, fontSize: 14 },
  error: { color: '#ef4444', background: '#fef2f2', border: '1px solid #fecaca', padding: '16px', borderRadius: 8, marginBottom: 16, fontSize: 14 },
  btn: { display: 'inline-block', marginTop: 16, padding: '14px 32px', background: '#2563eb', color: '#fff', border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 700, cursor: 'pointer', textDecoration: 'none' },
  link: { marginTop: 20, color: '#64748b' }
};

export default function VerifyEmail({ onLogin }) {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('loading');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) { setStatus('error'); setError('Invalid verification link.'); return; }
    api.get(`/auth/verify-email?token=${token}`)
      .then(res => {
        if (onLogin) onLogin(res.data.token, res.data.user);
        setStatus('success');
      })
      .catch(err => {
        setStatus('error');
        setError(err.response?.data?.error || 'Verification failed');
      });
  }, [token, onLogin]);

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.title}>Email Verification</div>
        {status === 'loading' && <div style={s.sub}>Verifying your email...</div>}
        {status === 'success' && (
          <>
            <div style={s.success}>Your email has been verified! You are now logged in.</div>
            <Link to="/" style={s.btn}>Go to Dashboard</Link>
          </>
        )}
        {status === 'error' && (
          <>
            <div style={s.error}>{error}</div>
            <div style={s.link}><Link to="/register">Register again</Link> or <Link to="/login">Sign in</Link></div>
          </>
        )}
      </div>
    </div>
  );
}
